import React from "react";

const ReplyMessageBar = ({ replyMessage, replyText }) => {
  if (!replyMessage && !replyText) return null;

  const extractReplyContent = (replyMessage) => {
    if (!replyMessage) return { text: null, items: null };

    let text;
    let items;
    
    switch (replyMessage?.type) {
      case 'location':
        text = replyMessage?.location?.name || 'Location';
        items = null;
        break;
      case 'interactive':
        text = replyMessage?.interactive?.body?.text || 'Interactive';
        items = replyMessage?.interactive?.body?.components;
        break;
      default:
        text = replyMessage.template?.map(item => item?.text);
        items = replyMessage.template?.map(item => item);
        break;
    }
    
    return { text, items };
  };

  const { text: reply_message, items: previewContent } = extractReplyContent(replyMessage);
  const displayText = replyText || reply_message;
  
  if (!displayText) return null;

  return (
    <div className="w-full flex-row align-center bg-[var(--channelButton)] inbox12px-400 rounded-r-[12px] rounded-l-[12px] text-[var(--font-600)]  mb-10">
      <div className="h-[6vh] bg-[#6564CA] w-1 rounded-l-[12px]"></div>
      <div className="flex flex-1 items-center justify-between">
        <div className="max-w-[20ch] truncate ml-10">
          {displayText}
        </div>
        {previewContent && (
          <div>
            {previewContent.map((item, index) => (
              <div key={index}>
                {item?.format === "IMAGE" && (
                  <img
                    src={item?.example?.header_handle?.[0]}
                    className="w-[50px] h-[50px] object-cover rounded-sm ml-10 mr-10"
                    alt="Reply preview"
                  />
                )}
                {item?.format === "VIDEO" && (
                  <video className="w-[50px] h-[50px] object-cover rounded-sm ml-10 mr-10">
                    <source src={item?.example?.header_handle?.[0]} type="video/mp4" />
                  </video>
                )}
                {item?.format === "DOCUMENT" && (
                  <iframe
                    className="w-[50px] h-[50px] object-cover rounded-sm ml-10 mr-10"
                    src={item?.example?.header_handle?.[0]}
                    title="Document preview"
                  />
                )}
                {item?.format === "AUDIO" && (
                  <audio className="w-[50px] h-[50px] object-cover rounded-sm ml-10 mr-10">
                    <source src={item?.example?.header_handle?.[0]} type="audio/mp3" />
                  </audio>
                )}
                {item?.format === "LOCATION" && (
                  <div>
                    location
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReplyMessageBar;
